//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import card from '@/components/card/card.vue';
import filterTool from '@/components/filterTool.vue';
import mgInput from '@/components/custom/mg-input.vue';
import empty from '@/components/empty.vue';
import mgSelect from '@/components/custom/mg-select.vue';
import badage from '@/components/badage.vue';
import { badage_api } from '@/api/api/user';
import { toTagPage, replaceToOriginStr } from '~/utils/tools';
import subscription from '@/components/subscription/subscription.vue';
import { isElectron } from '@/utils/constants';

let ticking = false;

const all_item = { cata_id: -1, cata_name: '全部', icon: 'feed', first_letter: 'qb' };
const FILTER_TYPE = {
  NEWEST: 1, // 最新发布
  COMMON: 0, // 综合排序
  HOT: 2, // 当前最热
};

export default {
  components: {
    filterTool,
    card,
    mgInput,
    empty,
    mgSelect,
    badage,
    subscription,
  },
  data() {
    return {
      loading: false,
      page_num: 1,
      page_size: 24,
      ip: '',
      resourceList: [],
      catalogs: [],
      searchVal: '',
      total: 0,
      swiperOption: {
        autoplay: 5000,
        spaceBetween: 30,
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
        // Some Swiper option/callback...
      },
      fixed: false,
      filterTop: 0,
      isEmpty: false,
      showBorder: false, // 是否展示筛选框下的boder
      filterOptions: [
        {
          value: FILTER_TYPE.NEWEST,
          label: '最新发布',
        },
        {
          value: FILTER_TYPE.COMMON,
          label: '综合排序',
        },
        {
          value: FILTER_TYPE.HOT,
          label: '当前最热',
        },
      ],
      defaultChoosed: FILTER_TYPE.NEWEST,
      showInput: false, // 初始状态下不显示输入框
      showBadge: false,
      badgeData: null,
      cataLables: [], // 分类对应tag
      needHoverTag: true,
    };
  },
  computed: {
    emptyText() {
      return this.isEmpty ? '没有搜索结果' : '没有上传资源~';
    },
    noMore() {
      return this.total && this.resourceList.length >= this.total;
    },
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
    action_position() {
      return this.searchVal ? 'search' : 'community';
    },
    banners() {
      return this.$store.state.app?.banners || [];
    },
    cata_name() {
      const current_letter = this.$route?.query?.cata_name;
      const current_item = this.catalogs.find((item) => item.first_letter === current_letter);
      return current_item?.cata_name || '全部';
    },
  },
  watch: {
    cata_name() {
      this.initData('change_cata');
      this.getCataTags();
    },
    showInput() {
      setTimeout(() => {
        this.$refs.filterTool?.handleScroll();
        if (!this.isMobileSize()) this.$refs.filterTool?.scrollShow();
      }, 300);
    },
  },
  mounted() {
    this.isClient = isElectron();
    const top = this.$refs.content.offsetTop;
    this.$nextTick(() => {
      this.filterTop = top;
      const topbar = this.$store.state.app.topbar;
      const filterHeight = this.$refs.filterTool?.$el.clientHeight;
      const cataTagHeight = this.$refs['cata-tag']?.$el.clientHeight || 0;
      this.filterTop = top - topbar - filterHeight - cataTagHeight;
      this.windowChange();
    });
    if (this.$store.state.user.userInfo?.id) {
      this.searchResource();
    }
    this.loadMoreData();
    this.getCataTags();
    this.$sensors.track('page_view', {
      action_position: 'community',
    });

    if (this.resourceList.length === 0) {
      const cataName = this.catalogs.includes(this.cata_name) ? this.cata_name : all_item.cata_name;
      this.changeType(cataName);
    }

    if (this.$store?.state?.user?.userInfo?.id) {
      this.initBadge();
    }
  },
  beforeDestroy() {
    this.clearCondition();
    window.removeEventListener('scroll', this.scrollEvent);
  },
  async asyncData({ app, query }) {
    app.head.title = `海量免费插画/图标/UI设计素材,交互设计模板,线框原型设计规范- MasterGo资源社区`;
    try {
      const params = {
        page_num: 1,
        page_size: 24,
        sort_type: 0,
      };
      query = query || {};

      let catalogs;
      let total = 0;
      let resourceList = [];
      let cata_name = all_item.cata_name;
      const requestUrl = '/community/api/by-catalog';
      const resCatalogs = await app.$axios.$get('/community/api/catalog');
      if (resCatalogs?.code === 'OK') {
        catalogs = resCatalogs.data || [];
        catalogs.unshift(all_item);
        if (query.cata_name !== all_item.first_letter) {
          const current_item = catalogs.find((item) => item.first_letter === query.cata_name);
          if (current_item) {
            cata_name = current_item.cata_name;
          }
        }
      }
      if (cata_name !== all_item.cata_name) {
        params.res_cata = cata_name;
        app.head.title = replaceToOriginStr(`${cata_name}-MasterGo 社区`);
      }

      const resResources = await app.$axios.$get(requestUrl, { params });
      if (resResources.code && resResources.code === 'OK') {
        resourceList = resResources.data || [];
        resourceList.forEach((item) => {
          item.favorite = false;
        });
        total = resResources.meta.page.total;
      }
      return {
        catalogs,
        resourceList,
        total,
        isEmpty: resourceList.length === 0,
      };
    } catch (e) {
      console.log('e----', e);
      return {};
    }
  },
  methods: {
    bannerInputFocus() {
      this.$refs.cata_input.showSearch();
    },
    chargeScroll() {
      this.$refs?.filterTool.resizeThrottler();
    },
    isMobileSize() {
      const clientWidth = document.body.clientWidth;
      return clientWidth <= 640;
    },
    windowChange() {
      if (this.isMobileSize()) {
        this.showInput = true;
      }
    },
    getOffset(el, direction) {
      let offsetL = 0;
      let offsetT = 0;
      while (el !== window.document.body && el != null) {
        offsetL += el.offsetLeft;
        offsetT += el.offsetTop;
        el = el.offsetParent;
      }
      if (direction === 'left') {
        return offsetL;
      }
      return offsetT;
    },
    handleScrollTop() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      const offsetTop = this.getOffset(this.$refs.stickHeader);
      this.fixed = scrollTop > offsetTop;
    },
    getInputVisible() {
      const input = this.$refs.banner_input?.$refs.input_wrap;
      if (!input) return;
      const position = input.getBoundingClientRect();
      this.showInput = position.top < 24;
    },
    toLoadMore() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      this.showBorder = scrollTop >= this.filterTop;
      const scrollTotal = scrollTop + clientHeight;
      const offsetBottom = 50;
      if (!this.noMore && !this.isEmpty && !this.loading) {
        if (scrollTotal + offsetBottom >= scrollHeight) {
          this.loadMore();
        }
      }
    },
    scrollEvent() {
      if (!ticking) {
        window.requestAnimationFrame(() => {
          this.clearHoverEvent();
          this.getInputVisible();
          this.toLoadMore();
          ticking = false;
        });
        ticking = true;
      }
    },
    clearHoverEvent() {
      this.needHoverTag = false;
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
        this.hoverTimer = null;
      }
      this.hoverTimer = setTimeout(() => {
        this.needHoverTag = true;
        this.hoverTimer = null;
      }, 200);
    },
    loadMoreData() {
      if (!window) {
        return;
      }
      window.addEventListener('scroll', this.scrollEvent);
    },
    async getCatalogs() {
      // 获取资源类目
      try {
        const { code, data } = await this.$axios.$get('community/api/catalog');
        if (code && code === 'OK') {
          const catalogs = data;
          catalogs.unshift(all_item);
          this.catalogs = catalogs;
        }
      } catch (error) {
        console.warn(error);
      }
    },
    changeFilter() {
      this.clearCondition();
      this.initData('change_cata');
    },
    changeType(cata_name) {
      this.clearCondition();

      const path = this.$route.path;
      const query = this.$route.query; // 这里可以用Vue的方法获取参数，也可以用正则的方法获取url中的参数
      const current_item = this.catalogs.find((item) => item.cata_name === cata_name);
      if (current_item) {
        const new_query = { ...query, cata_name: current_item.first_letter };
        this.$router.push({ path, query: new_query });
      }
    },
    clearCondition() {
      this.page_num = 1;
      // this.resourceList = [];
    },
    searchResource(type) {
      this.clearCondition();
      this.initData();
      if (type === 'banner' && !this.isMobileSize()) {
        this.bannerInputFocus();
      }
      if (!this.isMobileSize()) {
        this.showInput = false;
      }
    },
    jumpSearch() {
      window.open(
        this.$router.resolve({
          path: '/search',
          query: {
            cata_name: '资源',
            k: this.searchVal,
          },
        }).href,
      );
      this.searchVal = '';
    },
    scrollToTop() {
      const top = this.$refs.content.offsetTop;
      this.filterTop = top;
      const topbar = this.$store.state.app.topbar;
      const filterHeight = this.$refs.filterTool?.$el.clientHeight;
      const cataTagHeight = this.$refs['cata-tag']?.clientHeight || 0;
      this.filterTop = top - topbar - filterHeight - cataTagHeight;
      const clientHeight = document.documentElement.clientHeight || document.body.clientHeight;
      const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
      const scroll = scrollHeight - clientHeight;
      if (this.filterTop && scroll >= 0) {
        window.scrollTo({
          top: this.filterTop <= scroll ? this.filterTop : scroll - 10,
        });
      }
    },
    loadMore() {
      if (this.noMore || this.loading) return;
      this.page_num++;
      this.initData();
    },

    async initBadge() {
      try {
        const fname = 'webapi.enablebadgev2';
        const experimentRes = await this.$axios.$post('/api/v1/experiment/var/user', {
          fname,
        });
        const experiment = experimentRes.data;
        const isExper = experiment[fname] && experiment[fname].value === 'c1';
        if (isExper) {
          const res = await this.$axios.$post(badage_api.badage_action, {
            action: 'community_page_view',
          });
          const { code, data = {} } = res;
          if (code === 'OK' && data) {
            this.badgeData = data;
            this.showBadge = true;
          } else {
            this.showBadge = false;
          }
        }
      } catch (err) {
        this.showBadge = false;
        console.error(err);
      }
    },

    async initData(type) {
      this.loading = true;
      this.isEmpty = false;
      const params = {
        page_num: this.page_num,
        page_size: this.page_size,
        sort_type: this.defaultChoosed,
      };
      if (this.cata_name !== '全部') {
        params.res_cata = this.cata_name;
      }
      try {
        const requestUrl = 'community/api/by-catalog';
        const res = await this.$axios.$get(requestUrl, { params });
        const { code, data = [], meta } = res;
        if (code === 'OK') {
          this.loading = false;
          this.total = meta.page.total;
          if (this.resourceList.length && this.page_num !== 1) {
            if (data?.length) this.resourceList.push(...data);
          } else {
            this.resourceList = data || [];
          }
          if (!this.resourceList.length) {
            this.isEmpty = true;
          }
          this.$nextTick(() => {
            if (type === 'change_cata') this.scrollToTop();
          });
        }
      } catch (error) {
        console.warn(error);
      }
    },
    bannerClick(banner, index) {
      this.$sensors.track('get_resource', {
        action_position: 'banner',
        resource_id: banner.resource_id,
        action_detail: index + 1,
        resource_name: banner.res_name,
      });
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter0: 'community_resource',
        action_detail: `banner_${index + 1}`,
        action_type: 'click',
      });
    },
    // 插入相关资源6个
    async addLikeLists(resourceInfo) {
      if (resourceInfo.isLike) return;
      const res_label = resourceInfo.res_label ? JSON.parse(resourceInfo.res_label).join(',') : '';
      const res_cata = resourceInfo.res_cata ? JSON.parse(resourceInfo.res_cata).join(',') : '';
      const res_id = resourceInfo?.res_id || '';
      const resLike = await this.$axios.$post('/community/api/guess-like', {
        res_label,
        res_cata,
        res_id,
      });
      const addList = (resLike.data && resLike.data.map((item) => ({ ...item, isLike: true }))) || [];
      // 插入资源去重
      if (addList.length) this.getUniqueList(resourceInfo, addList);
    },
    getUniqueList(resourceInfo, addList) {
      const res_id = resourceInfo?.res_id || '';
      const index = res_id ? this.resourceList.findIndex((n) => n.res_id === res_id) : -1;
      const map = new Map();
      addList.forEach((item) => {
        map.set(item.res_id, item);
      });
      this.resourceList.forEach((item) => {
        if (map.has(item.res_id)) {
          map.delete(item.res_id);
        }
      });
      // 当前资源后面插入相关资源
      this.resourceList.splice(index + 1, 0, ...map.values());
    },
    async getCataTags() {
      const cata_id = this.catalogs.find((item) => item.cata_name === this.cata_name).cata_id;
      const params = { cata_id };
      try {
        const { code, data } = await this.$axios.$get('/community/api/catalog-label', { params });
        if (code && code === 'OK') {
          this.cataLables = data?.labels || [];
        }
      } catch (error) {
        console.warn(error);
      }
    },
    goTagPage(label) {
      toTagPage(label);
      this.setTagSensors();
    },
    setTagSensors() {
      this.$sensors.track('event_click', {
        action_position: 'community',
        action_parameter1: 'category',
      });
    },
    handelSubs() {
      this.$refs.subs?.addAccessNum();
    },
  },
};
